import { BaseResource } from './BaseResource';
import { DeliveryWindowResource } from './DeliveryWindow';
import { Locales } from './Locale';
import { DiscountResource } from './Prices';

export type ProductAttributeChoice = Record<Locales, string>;
export type ProductAttributeChoices = Record<string, ProductAttributeChoice>;

export interface ProductAttributeConfigurationResource extends BaseResource {
    choices: ProductAttributeChoices;
}

export interface ProductAttributeContentsResource extends BaseResource {
    name: string;
    code: string;
    configuration: ProductAttributeConfigurationResource;
}

export enum ProductAttributeType {
    text = 'text',
    number = 'float',
    boolean = 'checkbox',
    option = 'select',
}

export enum ProductAttributeKey {
    sku = 'sku',
    barcode = 'v_barcode',
    materials = 'v_material',
    colors = 'v_color',
    isNew = 'v_isNew',
    brand = 'v_brand',
    origin = 'v_origin',
    deliveryMin = 'v_deliveryMin',
    deliveryMax = 'v_deliveryMax',
    ranking = 'v_ranking',
    colli = 'colli',
    wattage = 'wattage',
}

export enum ProductDimensionAttributeKey {
    width = 'width',
    height = 'height',
    depth = 'depth',
    length = 'length',
    radius = 'radius', // Diameter, not the actual radius…
    weight = 'weight',
    carryWeight = 'carryWeight', // TODO L5W-866: Implement carryWeight, once available (might need to be renamed)
    volume = 'volume',
    cord = 'cord', // Length of cord
    seat = 'seat', // Depth of seat
    armrest = 'armrest', // Height of armrest
}

type ProductAttributeValue = string | string[] | number | boolean;

export interface ProductAttributeResource extends BaseResource {
    type: ProductAttributeType;
    name: string;
    code: ProductAttributeKey | ProductDimensionAttributeKey;
    attribute: ProductAttributeContentsResource;
    value: ProductAttributeValue;
    localeCode: string;
}

export interface ProductVariantBaseResource extends BaseResource {
    inStock: boolean;
    lowestPriceBeforeDiscount?: number;
    originalPrice: number;
    price: number;
}

interface Translation extends BaseResource {
    description: string;
    name: string;
    slug: string;
}

export interface ProductVariantResource extends ProductVariantBaseResource {
    loods5IdLegacy: number | null;
    code: string;
    product: string;
    variantId: string;
    variantCode: string;
    optionValues: string[];
    images: string[];
    name: string;
    relativeUrl: string;
    deliveryWindow: DeliveryWindowResource | null;
    attributes: ProductAttributeResource[];
    discount: DiscountResource | null;
    deleted: boolean;
    enabled: boolean;
    onHand: number;
    translations: Record<Locales, Translation>;
}
